import React, { useState } from "react";
import {
  Grid,
  TextField,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Button,
  Box,
  Card,
  CardContent,
  Typography,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import AddIcon from "@mui/icons-material/Add";
import PhotoCamera from "@mui/icons-material/PhotoCamera";

const DynamicForm = () => {
  const [specifications, setSpecifications] = useState([]);
  const [testimonials, setTestimonials] = useState([
    { sNo: 1, title: "", businessName: "", details: "", image: null },
  ]);
  const [shortOneLiner, setShortOneLiner] = useState("");
  const [details2, setDetails2] = useState("");

  const handleAddSpecification = () => {
    setSpecifications([...specifications, { title: "", details: "" }]);
  };

  const handleAddTestimonial = () => {
    setTestimonials([
      ...testimonials,
      {
        sNo: testimonials.length + 1,
        title: "",
        businessName: "",
        details: "",
        image: null,
      },
    ]);
  };

  const handleTestimonialChange = (index, field, value) => {
    const updatedTestimonials = [...testimonials];
    updatedTestimonials[index][field] = value;
    setTestimonials(updatedTestimonials);
  };

  const handleImageUpload = (index, event) => {
    const updatedTestimonials = [...testimonials];
    updatedTestimonials[index].image = event.target.files[0];
    setTestimonials(updatedTestimonials);
  };

  return (
    <Box sx={{ marginTop: "20px" }}>
      <Typography variant="h6">Pawn Broking Automation</Typography>
      <Card elevation={3} sx={{ mt: 2 }}>
        <CardContent>
          <Grid container spacing={2}>
            <Grid item xs={12} sm={12} md={4}>
              <TextField
                label="Short One Liner"
                fullWidth
                multiline
                value={shortOneLiner}
                onChange={(e) => setShortOneLiner(e.target.value)}
              />
            </Grid>

            <Grid item xs={12} sm={12} md={4}>
              <TextField
                label="Details 2"
                fullWidth
                multiline
                value={details2}
                onChange={(e) => setDetails2(e.target.value)}
              />
            </Grid>

            <Grid item xs={12} md={6}>
              <Accordion>
                <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                  Specifications
                </AccordionSummary>
                <AccordionDetails>
                  {specifications.map((spec, index) => (
                    <Grid container spacing={2} key={index} mt={2}>
                      <Grid item xs={12}>
                        <TextField
                          label={`Specification ${index + 1}`}
                          fullWidth
                          value={spec.title}
                          onChange={(e) =>
                            handleTestimonialChange(
                              index,
                              "title",
                              e.target.value
                            )
                          }
                        />
                      </Grid>
                      <Grid item xs={12}>
                        <TextField
                          label="Details"
                          fullWidth
                          multiline
                          rows={3}
                          value={spec.details}
                          onChange={(e) =>
                            handleTestimonialChange(
                              index,
                              "details",
                              e.target.value
                            )
                          }
                        />
                      </Grid>
                    </Grid>
                  ))}
                  <Button
                    onClick={handleAddSpecification}
                    startIcon={<AddIcon />}
                    variant="contained"
                    sx={{ mt: 2 }}
                  >
                    Add Specification
                  </Button>
                </AccordionDetails>
              </Accordion>
            </Grid>
            <Grid item xs={12} md={6}>
              <Accordion>
                <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                  Testimonials
                </AccordionSummary>
                <AccordionDetails>
                  {testimonials.map((test, index) => (
                    <Grid container spacing={2} mt={2} key={index}>
                      <Grid item xs={12} sm={6} md={4}>
                        <TextField
                          label="S.No."
                          disabled
                          fullWidth
                          value={test.sNo}
                        />
                      </Grid>
                      <Grid item xs={12} sm={6} md={4}>
                        <TextField
                          label="Title"
                          fullWidth
                          value={test.title}
                          onChange={(e) =>
                            handleTestimonialChange(
                              index,
                              "title",
                              e.target.value
                            )
                          }
                        />
                      </Grid>
                      <Grid item xs={12} sm={6} md={4}>
                        <TextField
                          label="Business Name"
                          fullWidth
                          value={test.businessName}
                          onChange={(e) =>
                            handleTestimonialChange(
                              index,
                              "businessName",
                              e.target.value
                            )
                          }
                        />
                      </Grid>
                      <Grid item xs={12}>
                        <TextField
                          label="Details"
                          fullWidth
                          multiline
                          rows={3}
                          value={test.details}
                          onChange={(e) =>
                            handleTestimonialChange(
                              index,
                              "details",
                              e.target.value
                            )
                          }
                        />
                      </Grid>
                      <Grid item xs={12}>
                        <Button
                          variant="contained"
                          component="label"
                          startIcon={<PhotoCamera />}
                        >
                          Upload Image
                          <input
                            type="file"
                            accept="image/*"
                            hidden
                            onChange={(e) => handleImageUpload(index, e)}
                          />
                        </Button>
                      </Grid>
                    </Grid>
                  ))}
                  <Button
                    onClick={handleAddTestimonial}
                    startIcon={<AddIcon />}
                    variant="contained"
                    sx={{ mt: 2 }}
                  >
                    Add Testimonial
                  </Button>
                </AccordionDetails>
              </Accordion>
            </Grid>
          </Grid>
          <Box
            sx={{
              display: "flex",
              justifyContent: "flex-end",
              marginTop: 2,
            }}
          >
            <Button
              variant="contained"
              sx={{
                height: "100%",
                background: "linear-gradient(45deg, #ff4b2b 30%, #ff416c 90%)",
                color: "#fff",
                borderRadius: "8px",
                boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.2)",
                textTransform: "uppercase",
                fontWeight: "bold",
                "&:hover": {
                  background:
                    "linear-gradient(45deg, #ff416c 30%, #ff4b2b 90%)",
                  boxShadow: "0px 6px 16px rgba(0, 0, 0, 0.3)",
                },
              }}
            >
              Submit
            </Button>
          </Box>
        </CardContent>
      </Card>
    </Box>
  );
};

export default DynamicForm;
